module.exports = __webpack_public_path__ + "img/papel-toalha-mobile.128ea2bf.png";